import * as React from "react";
import TextareaAutosize from "react-textarea-autosize";

import { useEffect, useState } from "react";
import { VideoProjectServices } from "@/services";
import { CustomModal } from "@/components/CustomModal";

interface Props {
  open: boolean;
  onClose: () => void;
  playerId?: string | number;
  coachId?: string | number;
}

const ClientNotesModalFC: React.FC<Props> = ({ open, playerId, coachId, onClose }) => {
  const [notesText, setNotesText] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsLoading(true);
    if (open && playerId) {
      VideoProjectServices.getPlayerNotes(playerId)
        .then(notes => {
          setNotesText(notes?.notes || "");
          setIsLoading(false);
        })
        .catch(() => {
          alert("Error fetching player notes");
          setIsLoading(false);
        });
    } else if (open && coachId) {
      VideoProjectServices.getCoachNotes(coachId)
        .then(notes => {
          setNotesText(notes?.notes || "");
          setIsLoading(false);
        })
        .catch(() => {
          alert("Error fetching coach notes");
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [open, playerId, coachId]);

  const updateClientNotes = async () => {
    if (playerId) {
      await VideoProjectServices.addClientNotes(playerId, notesText);
    } else if (coachId) {
      await VideoProjectServices.addCoachClientNotes(coachId, notesText);
    }

    setNotesText("");
    onClose();
  };

  return (
    open && (
      <CustomModal
        title={`Edit Notes`}
        acceptLabel="Save"
        acceptHandler={updateClientNotes}
        rejectHandler={() => onClose()}
      >
        <label>
          <b>{isLoading ? "Loading..." : coachId ? "Coach" : "Player"} Notes</b>
        </label>
        <TextareaAutosize
          data-elm-id={"notesInput"}
          className="clientNotesField"
          placeholder={"Add client notes..."}
          rows={3}
          value={notesText}
          onChange={data => {
            setNotesText(data.currentTarget.value);
          }}
        />
      </CustomModal>
    )
  );
};

export const ClientNotesModal = ClientNotesModalFC;
